import { For } from 'solid-js'

const stats = [
  { value: '1,200+', label: 'Active Creators' },
  { value: '100K+', label: 'Images Generated' },
  { value: '50K+', label: 'Community Members' },
  { value: '300+', label: 'Characters' },
]

export default function StatsBand() {
  return (
    <section
      class="w-full"
      style={{
        background: 'rgba(255,255,255,0.02)',
        'border-top': '1px solid rgba(255,255,255,0.07)',
        'border-bottom': '1px solid rgba(255,255,255,0.07)',
      }}
    >
      <div class="mx-auto grid max-w-[var(--cf-content-max)] grid-cols-2 gap-y-6 px-[var(--cf-gutter)] py-8 md:grid-cols-4 md:gap-y-0 md:py-10">
        <For each={stats}>
          {(stat, i) => (
            <div
              class="flex flex-col items-center gap-1"
              classList={{
                'md:border-r md:border-white/[0.07]': i() < stats.length - 1,
              }}
            >
              <span
                class="font-bebas leading-none"
                style={{
                  'font-size': 'clamp(32px, 4vw, 56px)',
                  'letter-spacing': '1px',
                  background: 'linear-gradient(135deg, #fff, var(--cf-pink))',
                  '-webkit-background-clip': 'text',
                  'background-clip': 'text',
                  '-webkit-text-fill-color': 'transparent',
                  color: 'transparent',
                }}
              >
                {stat.value}
              </span>
              <span
                class="font-rajdhani font-bold uppercase"
                style={{
                  'font-size': '11px',
                  'letter-spacing': '1.6px',
                  color: 'var(--cf-muted)',
                }}
              >
                {stat.label}
              </span>
            </div>
          )}
        </For>
      </div>
    </section>
  )
}
